import React, { useEffect, useState } from 'react';
import Logo from '../../images/logo.png'
import { QRCodeCanvas } from 'qrcode.react';

function formatNumber(number, length) {
    return String(number).padStart(length, '0');
}

function convertNumberToWords (number) {
    const units = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
    ];
    const tens = [
      "",
      "Ten",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    const teens = [
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const crore = "Crore";
    const lakh = "Lakh";
    const arab = "Arab";
    const currency = "Rupees";
    const paisa = "Paisa";
    
    if (number === 0) {
      return "Zero " + currency;
    }

    let words = "";
    
    if (number >= 1000000000) {
      words +=
        convertNumberToWords(Math.floor(number / 1000000000)) +
        " " +
        arab +
        " ";
      number %= 1000000000;
    }
    if (number >= 10000000) {
      words +=
        convertNumberToWords(Math.floor(number / 10000000)) + " " + crore + " ";
      number %= 10000000;
    }

    if (number >= 100000) {
      words +=
        convertNumberToWords(Math.floor(number / 100000)) + " " + lakh + " ";
      number %= 100000;
    }

    if (number >= 1000) {
      words += convertNumberToWords(Math.floor(number / 1000)) + " Thousand ";
      number %= 1000;
    }

    if (number >= 100) {
      words += convertNumberToWords(Math.floor(number / 100)) + " Hundred ";
      number %= 100;
    }

    if (number >= 20) {
      words += tens[Math.floor(number / 10)] + " ";
      number %= 10;
    } else if (number >= 10) {
      //console.log(number);
      words += teens[number - 10] + " ";
      number = 0;
      //console.log(words);
    }

    if (number > 0) {
      words += units[number] + " ";
    }
    const decimalPart = Math.round((number % 1) * 100);
    //console.log(decimalPart);
    if (decimalPart > 0) {
      words += "and" + decimalPart + " " + paisa + "only ";
    }
    
    //console.log(words);
    return words.trim() + " ";
  };

const InvoicePage = (orderDatas) => {

    const userID = sessionStorage.getItem("TRCUserId");
    const userEmail = sessionStorage.getItem("TRCUserEmail");
    const userName = sessionStorage.getItem("TRCUserName");
    const userPosition = sessionStorage.getItem("TRCUserPosition");

    const getData = orderDatas?.getData;
    const [total, setTotal] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);
    const [gst, setGST] = useState(0);
    const [qty, setQty] = useState(0);
    const [discount, setDiscount] = useState(getData?.discount || 0);
    const [scheme, setScheme] = useState(getData?.schemeValue || 0);
    const [crates, setCrates] = useState(0);
    const [weight, setWeight] = useState(0);
    const [discounts, setDiscounts] = useState(JSON.parse(getData?.discountData || '[]'));
    
    // console.log(getData);

    const companyData = {
        companyName: "TRUCOO DAIRY PRODUCTS PRIVATE LIMITED",
        companyAddress1: "C202, SK Hill view Apartment",
        companyAddress2: "Rainbow Enclave",
        companyLocation: "Sugunapuram Mylkal",
        companyCity: "Coimbatore",
        companyState: "Tamil Nadu",
        companyZip: "641008",
        companyPhone: "+91 81900 03400",
        companyEmail: "cbeoffice@trucoo.in",
        companyGst: "33AKCT9681P1ZC",
        ts: "Sample Terms and Conditions"
    };   

    // function customRound(num) {
    //     const decimalPart = num % 1;
    //     if (decimalPart < 0.5) {
    //       return Math.floor(num) + 0.5;
    //     } else {
    //       return Math.ceil(num);
    //     }
    // };

    const getTotal = () => {
        let allTotal = 0;
        let allGst = 0;
        let allQty = 0;
        let allSubTotal = 0;
        let discount = 0;
        let crate = 0;
        let weight = 0;
    
        getData?.orderData?.forEach(data => {
            const price = parseFloat(data.itemPrice) || 0;
            const gst = parseFloat(data.itemGst) || 0;
            const disCrates = getDiscountCrates(data.itemId);
            
            const productGst = price - (price / (1 + gst / 100)) || 0;
            const productPrice = price - productGst || 0;
    
            allTotal += price * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade);
            allGst += productGst * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade);
            allSubTotal += productPrice * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade);
            allQty += (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)|| 0;
            crate += (parseFloat(data.qty) + parseFloat(disCrates));
            weight +=  (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade) * (parseFloat(data.itemWeight)/1000);
    
            
        });
    
        discount += parseFloat(getData?.discount) || 0;
        // Set the final values
        setTotal(allSubTotal);
        setGST(allGst);
        setQty(allQty);
        setGrandTotal(allTotal);
        setDiscount(discount);
        setScheme(parseFloat(getData?.schemeValue || 0));
        setCrates(crate);
        setWeight(weight);
    };

    const getDiscountCrates = (product) => {
     
        const productData = getData?.orderData?.find(items => items.itemId === product);
        const discountData = discounts?.find(items => items.item === product); 

        if (!productData || !discountData) {
            console.warn("Product or discount not found");
            return 0; 
        }
    
        const qty = parseFloat(productData.qty);
        const price = parseFloat(productData.itemPrice);
        const crates = parseFloat(productData.itemGrade);
        const weight = parseFloat(productData.itemWeight);
        const gst = parseFloat(productData.itemGst);
        const productGst = price - (price / (1 + gst / 100)) || 0;
        const productPrice = price - productGst || 0;
    
        if (isNaN(qty) || isNaN(productPrice) || isNaN(crates) || isNaN(weight)) {
            console.warn("Invalid product data");
            return 0;
        }
    
        if (!discountData.value || isNaN(discountData.value)) {
            console.warn("Invalid discount value");
            return 0;
        }

        if(discountData.discount === 'amount'){
            return 0;
        }
    
        if (discountData.type === 'grade') {
            if (discountData.crate === 'packet') {
                return (parseFloat(discountData.value) * qty) / crates;
            } else {
                return ((parseFloat(discountData.value) * qty) / productPrice) / crates;
            }
        }
    
        if (discountData.type === 'percent') {
            const total = qty * crates * productPrice;
            return total * (parseFloat(discountData.value) / 100);
        }
    
        if (discountData.type === 'liters') {
            if (discountData.crate === 'litre') {
                const ltrs = qty * crates * (weight/1000);
                const discLtr = ltrs * discountData.value;
                return (discLtr / crates);
            } else {
                const ltrs = qty * crates * (weight/1000);
                const ltrprice = ltrs * discountData.value;
                const ltrQty = ltrprice/productPrice;
                return (ltrQty / crates);
            }
        }
    
        return 0;
    };

    
    const formatViewDate = (date) => {
        if(!date){
            return
        }
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${String(newDate.getDate()).padStart(2, '0')}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${newDate.getFullYear()}`;
        return formattedDate;
    };


    const payable = (parseFloat(grandTotal) - parseFloat(discount) - parseFloat(scheme)).toFixed(2);
    const totalAmountInWords = convertNumberToWords(parseFloat( Math.round(payable)).toFixed(0));

    const ewayQr = `EWB no. : ${getData?.eWayNum} / ${companyData?.companyGst} / Date : ${formatViewDate(getData?.date)}`;
      

    useEffect(() => {
        getTotal();
        setDiscounts(JSON.parse(getData?.discountData || '[]'));
    },[getData]);

    useEffect(() => {
        getTotal();
    },[discounts]);

    const note = `DC/${getData?.invoiceId}/${getFiscalYearLabel(new Date(getData?.dealerData?.date))}`;
    const upiId = 'QR919843022841-0082@unionbankofindia';
    const payeeName = 'TRUCOO DAIRY PRODUCTS PRIVATE LIMITED';
    const payableQR = parseFloat(Math.round(payable).toFixed(2));

    const generateUpiLink = () => {
        const upiLink = `upi://pay?pa=${upiId}&am=${payableQR}&cu=INR&pn=${payeeName}&tn=${note}`;
        return upiLink;
    };


    function getFiscalYearLabel(date = new Date()) {
        const year = date.getFullYear();
        const month = date.getMonth(); 
        if (month < 3) {
          return `${(year-1).toString().slice(-2)}-${year.toString().slice(-2)}`;
        } else {
          return `${year.toString().slice(-2)}-${(year + 1).toString().slice(-2)}`;
        }
    };


    const i = 17 - getData?.orderData?.length;

    return (
<>
        {/* --------------Sheet 1 ------------ */}

        <section className="invoice hide" id="printableArea1"  style={{ maxWidth: '100%', padding: '10mm', boxSizing: 'border-box', border: '1px solid #000', justifyContent: 'center' }}>
                        <div style={{marginTop: '-10px', marginBottom: '10px'}}>
                            <small >( ORIGINAL FOR RECIPIENT )</small>
                        </div>
                        <div className="row align-items-center justify-content-md-center h-p100">
                            <div className="col-sm-2">
                                <img src={Logo} width="100%" />
                            </div>

                            <div className="col-sm-5 text-fade" align="left">
                                <h6 className="text-left text-dark" style={{fontWeight: '600'}}>{companyData?.companyName}</h6>
                                <address className="text-left">
                                    {companyData?.companyAddress1}, {companyData?.companyAddress2}
                                    <br></br>
                                    {companyData?.companyLocation}, {companyData?.companyCity},
                                    {companyData?.companyState} - {companyData?.companyZip} <br />
                                    Ph: {companyData?.companyPhone}<br />
                                    {companyData?.companyGst}<br />
                                </address>
                            </div>

                            <div className="col-sm-3 d-flex" align="left">
                               <p class="text-dark">
                                Date : {formatViewDate(getData?.date)}<br />
                                DC No : DC/{getData?.invoiceId}/{getFiscalYearLabel(new Date(getData?.date))}<br />
                                {/* Route : {getData?.dealerData?.routes} <br />
                                Place : {getData?.dealerData?.locations}<br /> */}
                                Vehicle No : {getData?.vNum}<br />
                                E-Way Bill : {getData?.eWayNum}
                               </p>
                            </div>

                            <div className="col-sm-2 d-flex justify-content-end mb-4">
                               {/* <img src={Qr} alt="QR Code" width="200px" style={{marginRight: '-20px'}} /> */}
                               { payable && payable > 0 && <QRCodeCanvas value={generateUpiLink()} size={150}  /> }
                            </div>


                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th className="text-center" colspan="3">Delivery Chellan</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td width="33.3333%" className="text-dark">
                                                <address >
                                                    <p className="text-dark text-uppercase">Billing Address</p>
                                                    <h6 style={{fontWeight: '600', fontSize: '14px'}}>{getData?.dealerData?.dealer}</h6>
                                                    {/* <p>{getData?.dealerData?.name}</p> */}
                                                    <p>{getData?.dealerData?.address}</p>
                                                    <p>{getData?.dealerData?.phone}<br />{getData?.dealerData?.email}</p>
                                                    GSTIN : &nbsp;&nbsp;&nbsp;{getData?.dealerData?.gst}<br />
                                                    State : &nbsp;&nbsp;&nbsp;{getData?.dealerData?.state} &nbsp;&nbsp;&nbsp;
                                                    Code : &nbsp;&nbsp;&nbsp;{getData?.dealerData?.stateCode}
                                                </address>
                                            </td>
                                            <td width="33.3333%" className="text-dark" style={{verticalAlign: 'top'}}>
                                                <address >
                                                    <p className="text-dark text-uppercase">Shipping Address</p>
                                                    <h6 style={{fontWeight: '600', fontSize: '14px'}}>{getData?.shipping?.company}</h6>
                                                    {/* <p>{getData?.name}</p> */}
                                                    <p>{getData?.shipping?.address}</p>
                                                    <p>{getData?.shipping?.phone}<br />{getData?.shipping?.email}</p>
                                                </address>
                                            </td>
                                            <td className="text-dark" style={{verticalAlign: 'top'}}>
                                                <address >
                                                    <p className="text-dark text-uppercase">Dispatch From</p>
                                                    <h6 style={{fontWeight: '600', fontSize: '14px'}}>{getData?.dispatch?.company}</h6>
                                                    {/* <p>{getData?.name}</p> */}
                                                    <p>{getData?.dispatch?.address}</p>
                                                    <p>{getData?.dispatch?.phone}<br />{getData?.dispatch?.email}</p>
                                                </address>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="table-responsive ">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr className="fs-10 fw-600 text-dark">
                                            <th rowspan="2" width="3%">S.No</th>
                                            <th rowspan="2">PARTICULARS</th>
                                            <th rowspan="2" width="8%">HSN/SAC</th>
                                            <th rowspan="2" width="4%">UNIT</th>
                                            <th rowspan="2" width="8%">CRATES</th>
                                            <th rowspan="2" width="8%">QTY</th>
                                            <th rowspan="2" width="8%">LTR/KG</th>
                                            <th rowspan="2" width="6%">RATE/QTY</th>
                                            <th rowspan="2" width="8%">AMOUNT</th>
                                            {getData?.dealerData?.gstType === 'SGST' ? 
                                                <>
                                                    <th colspan="2" width="8%">CGST</th>   
                                                    <th colspan="2" width="8%">SGST</th>
                                                </>
                                            :
                                                <th colspan="2" width="8%">IGST</th>  
                                            }
                                            <th rowspan="2" width="10%">Total Amount</th>
                                        </tr>
                                        <tr className="fs-10 fw-800 text-dark">
                                            {getData?.dealerData?.gstType === 'SGST' && 
                                            <>
                                                <th>Rate(%) </th>
                                                <th>Value </th>
                                            </>
                                            }
                                          <th>Rate(%) </th>
                                          <th>Value </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {getData?.orderData?.map((data, index) => {
                                          
                                            const price = parseFloat(data.itemPrice);
                                            const gst = parseFloat(data.itemGst);
                                            const productGst = parseFloat(price - ( price / (1+ gst/100) ));
                                            const productPrice = parseFloat(price - productGst);
                                            const disCrates = getDiscountCrates(data.itemId);

                                            return(
                                            <tr key={index} className="fw-400 text-gray-600  fs-12">
                                                <td>{index + 1}</td> 
                                                <td class="text-left">{data.itemName}</td>
                                                <td class="text-left">{data.itemHsn}</td>
                                                <td>{data.itemUnit}</td>
                                                <td>{((parseFloat(data.qty) + parseFloat(disCrates))).toFixed(2)}</td>
                                                <td>{((parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)).toFixed(2)}</td>
                                                <td>{((parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade) * parseFloat(data.itemWeight)/1000).toFixed(2)}</td>
                                                <td>{parseFloat(productPrice).toFixed(2)}</td>
                                                <td>{parseFloat(productPrice.toFixed(2)* (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)).toFixed(2)}</td>
                                                {getData?.dealerData?.gstType === 'SGST' ?
                                                    <>
                                                        <td>{parseFloat(data.itemGst/2).toFixed(1)}%</td>
                                                        <td>{parseFloat((productGst.toFixed(2)/2) * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)).toFixed(2)}</td>
                                                        <td>{parseFloat(data.itemGst/2).toFixed(1)}%</td>
                                                        <td>{parseFloat((productGst.toFixed(2)/2) * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)).toFixed(2)}</td>
                                                    </>
                                                :
                                                    <>
                                                        <td>{parseFloat(data.itemGst).toFixed(1)}%</td>
                                                        <td>{parseFloat((productGst.toFixed(2)) * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)).toFixed(2)}</td>
                                                    </>
                                                }
                                                <td class="text-end">{(parseFloat(data.itemPrice) * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)).toFixed(2)}</td>

                                                                                                
                                            </tr>);
                                           })}
                                       
                                        {i > 1 &&
                                        
                                            Array.from({ length: i }).map((_, j) => (
                                                <tr className="force-no-border">
                                                    <td key={j} colSpan={14} className="p-3 force-no-border" style={{border: 'none'}}></td>
                                                </tr>
                                            ))
                                        }

                                        <tr>
                                            
                                        <th colspan="4">TOTAL</th>
                                           
                                           <th>{parseFloat(crates).toFixed(2)}</th>
                                           <th>{parseFloat(qty).toFixed(2)}</th>
                                           <th>{parseFloat(weight).toFixed(2)}</th>
                                           <th></th>
                                           <th>{parseFloat(total).toFixed(2)}</th>
                                           {getData?.dealerData?.gstType === 'SGST' ?
                                                <>
                                                    <th></th>
                                                    <th>{parseFloat(gst/2).toFixed(2)}</th>
                                                    <td></td>
                                                    <th>{parseFloat(gst/2).toFixed(2)}</th>
                                                </>
                                           : 
                                                <>
                                                    <td></td>
                                                    <th>{parseFloat(gst).toFixed(2)}</th>
                                                </>
                                            }
                                           <th class="text-end">{parseFloat(grandTotal).toFixed(2)}</th>

   
                                        </tr>
                                        
                                        <tr>
                                            <td  className="text-center" colSpan={getData?.dealerData?.gstType === 'SGST' ? 8 : 7}>
                                                Our Bank Details
                                            </td>
                                            <td className="text-left" colSpan={getData?.dealerData?.gstType === 'SGST' ? 7 : 6} rowspan="2">
                                                <small>We request you to make the payment through our UPI ID <br />QR919843022841-0082@unionbankofindia</small>
                                            </td>
                                        </tr>
                                        <tr>
                                        <td  className="text-end" colSpan="2">
                                                <span>A/C Holder</span> <br />
                                                <span>BANK</span><br />
                                                <span>BRANCH</span>  <br />
                                                <span>A/C NO</span> <br />
                                                <span>IFSC CODE</span>
                                            </td>
                                            <td  className="text-left" colSpan={getData?.dealerData?.gstType === 'SGST' ? 6 : 5}>
                                                <span>TRUCOO DAIRY PRODUCTS PRIVATE LIMITED</span> <br />
                                                <span>UNION BANK OF INDIA</span><br />
                                                <span>COIMBATORE</span> <br />
                                                <span>008311010000082</span> <br />
                                                <span>UBIN0800830</span>
                                            </td>
                                        </tr>
                                       
                                       
                                        <tr>
                                            <td className="text-left" colSpan={getData?.dealerData?.gstType === 'SGST' ? 9 : 7} >Electronic Referance Number :</td>
                                            <td className="text-left" colSpan="3">BILL AMOUNT</td>
                                            <td class="text-end" colSpan="2">{parseFloat(grandTotal).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <th className="text-start" colSpan={getData?.dealerData?.gstType === 'SGST' ? 9 : 7} rowspan="3" style={{padding: '15px 5px'}}>
                                                Payable Amount In words <br />{totalAmountInWords.toUpperCase()} RUPEES ONLY
                                            </th>
                                            <td className="text-left" colSpan="3">DISCOUNT</td>
                                            <td class="text-end" colSpan="2">{parseFloat(discount + scheme).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td className="text-left" colSpan="3" style={{padding: '15px 5px'}}>ROUND AMOUNT</td>
                                            <td class="text-end" colSpan="2">{parseFloat(Math.round(payable)).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                           
                                            <th className="text-left" colSpan="3">GRAND TOTAL</th>
                                            <th class="text-end" colSpan="2">{parseFloat(Math.round(payable)).toFixed(2)}</th>
                                        </tr>
                                        <tr>
                                            
                                        </tr>
                                        <tr>
                                            <td className="text-left" colSpan="5">E. & O.E</td>
                                            <td className="text-center" colSpan="9">{companyData?.companyName}</td>
                                        </tr>
                                        <tr>
                                          <td className="text-left" colSpan="2" style={{paddingBottom: '90px'}}>Received By</td>
                                          <td className="text-left" colSpan="3" style={{paddingBottom: '90px'}}>Prepared By  <br /><br />{userName}</td>
                                          <td className="text-left" colSpan="4" style={{paddingBottom: '90px'}}>Declaration <br />
                                          We declare that this invoice shows the actual price of the goods described and that all particulars are true and correct.</td>
                                          <td className="text-left" colSpan="5" style={{paddingBottom: '90px'}}>Authorized Signature</td>
                                        </tr>
                                        <tr>
                                            <td className="text-center" colSpan="14" >This is a Computer Generated Delivery Challan</td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>                                           

                        </div>
        </section>

        {/* --------------Sheet 2 ------------ */}

        <section className="invoice hide" id="printableArea2"  style={{ maxWidth: '100%', padding: '10mm', boxSizing: 'border-box', border: '1px solid #000', justifyContent: 'center' }}>
                        <div className="row align-items-center justify-content-md-center h-p100">
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th colspan="3" className="text-center border-bottom text-bold" style={{padding: '20px 5px'}}>E-Way Bill</th>
                                        </tr>
                                    </thead>
                                    
                                    <tbody>
                                        <tr>
                                            <td colspan="2" className="text-dark border-bottom" style={{paddingTop: '20px'}}>
                                               Doc No. : <b>Delivery Chellan - DC/{getData?.invoiceId}/{getFiscalYearLabel(new Date(getData?.date))}</b> <br />
                                               Date : <b>{formatViewDate(getData?.date)}</b>
                                            </td>
                                            <td className="text-dark border-bottom text-end" style={{paddingTop: '20px'}}>
                                            { payable && payable > 0 && <QRCodeCanvas value={ewayQr} size={150}  /> }
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table class="table">
                                    <tr>
                                        <th colspan="3" style={{padding: '20px 0px'}}>1. E-Way Bill Details</th>
                                    </tr>
                                    <tr>
                                        <td style={{padding: '0px 20px'}}><span>E-Way Bill No. : <b>{getData?.eWayNum}</b></span></td>
                                        <td style={{padding: '0px 20px'}}><span>Mode : <b>
                                                              {getData?.ewb?.tMode === "1"
                                                                ? "1-Road"
                                                                : getData?.ewb?.tMode === "2"
                                                                ? "2-Rail"
                                                                : getData?.ewb?.tMode === "3"
                                                                ? "3-Air"
                                                                : getData?.ewb?.tMode === "4"
                                                                ? "4-Ship"
                                                                : `${getData?.ewb?.tMode}-Unknown`}
                                                            </b></span></td>
                                        <td style={{padding: '0px 20px'}}><span>Generated Date : <b>{getData?.ewb?.created}</b> </span></td>
                                    </tr>
                                    <tr>
                                        <td style={{padding: '0px 20px'}}><span>Generated By : <b>{companyData?.companyGst}</b> </span></td>
                                        <td style={{padding: '0px 20px'}}><span>Approx Distance : <b>{getData?.ewb?.dist} KM</b> </span></td>
                                        <td style={{padding: '0px 20px'}}><span>Valid Upto : <b>{getData?.ewb?.valid}</b> </span></td>
                                    </tr>
                                    <tr>
                                        <td className="text-dark border-bottom" style={{padding: '0px 20px'}}>Supply Type : <b>
                                                            {getData?.ewb?.sType === "O"
                                                              ? "Outward-Supply"
                                                              : "Inward-Supply"}
                                                          </b></td>
                                        <td className="text-dark border-bottom" style={{padding: '0px 20px'}} colspan="2" >Transaction Type : <b>
                                                            {getData?.ewb?.docType === "INV"
                                                              ? "Tax Invoice"
                                                              : getData?.ewb?.docType === "CHL"
                                                              ? "Delivery Challan"
                                                              : getData?.ewb?.docType === "BIL"
                                                              ? "Bill of Supply"
                                                              : getData?.ewb?.docType === "BOE"
                                                              ? "Bill of Entry"
                                                              : "Others"}
                                                          </b></td>
                                    </tr>
                                   
                                </table>

                                <table className="table">
                                    <tr>
                                        <th colspan="2" style={{paddingTop: '20px'}}>2. Address Details</th>
                                    </tr>
                                    <tr>
                                        <td width="50%" style={{padding: '10px 20px'}}>
                                            <span class="text-bold">From</span><br />
                                            <span>
                                                {companyData?.companyName} <br />
                                                {companyData?.companyAddress1}, {companyData?.companyAddress2}
                                                {companyData?.companyLocation}, {companyData?.companyCity},
                                                {companyData?.companyState} - {companyData?.companyZip}
                                            </span>
                                        </td>
                                        <td width="50%" style={{padding: '10px 20px'}}>
                                            <span class="text-bold">To</span><br />
                                            <span>
                                                {getData?.dealerData?.dealer}<br />
                                                {getData?.dealerData?.address}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td width="50%" className="text-dark border-bottom" style={{padding: '10px 20px'}}>
                                            <span class="text-bold">Dispatch From</span><br />
                                            <span>
                                            {getData?.dispatch?.company}<br />
                                            {getData?.dispatch?.address}
                                            </span>
                                        </td>
                                        <td width="50%" className="text-dark border-bottom" style={{padding: '10px 20px'}}>
                                            <span class="text-bold">Ships To</span><br />
                                            <span>
                                                {getData?.shipping?.company}<br />
                                                {getData?.shipping?.address}
                                            </span>
                                        </td>
                                    </tr>
                                </table>

                                <table className="table">
                                              <tr>
                                                <th colspan="5" style={{ padding: "20px 0px" }}>
                                                  3. Goods Details
                                                </th>
                                              </tr>
                                              <tr className="table-bordered">
                                                <th style={{ padding: "10px 20px" }} width="10%">
                                                  HSN Code
                                                </th>
                                                <th style={{ padding: "10px 20px" }}>Product Name</th>
                                                <th
                                                  style={{ padding: "10px 20px" }}
                                                  width="10%"
                                                  class="text-end"
                                                >
                                                  Quantity
                                                </th>
                                                <th
                                                  style={{ padding: "10px 20px" }}
                                                  width="15%"
                                                  class="text-end"
                                                >
                                                  Taxable Amount
                                                </th>
                                                <th
                                                  style={{ padding: "10px 20px" }}
                                                  width="15%"
                                                  class="text-end"
                                                >
                                                  Tax Rate
                                                </th>
                                              </tr>
                                              {getData?.orderData?.map((data, index) => {
                                                const price = parseFloat(data.itemPrice);
                                                const gst = parseFloat(data.itemGst);
                                                const productGst = parseFloat(price - price / (1 + gst / 100));
                                                const productPrice = parseFloat(price - productGst);
                                                const disCrates = getDiscountCrates(data.itemId);
                                
                                                return (
                                                  <tr className="table-bordered">
                                                    <td style={{ padding: "5px 20px" }}>{data.itemHsn}</td>
                                                    <td style={{ padding: "5px 20px" }}>{data.itemName}</td>
                                                    <td style={{ padding: "5px 20px" }} class="text-end">
                                                      {data.qty}
                                                    </td>
                                                    <td style={{ padding: "5px 20px" }} class="text-end">
                                                      {parseFloat(
                                                        productPrice *
                                                          (parseFloat(data.qty) + parseFloat(disCrates)) *
                                                          parseFloat(data.itemGrade)
                                                      ).toFixed(2)}
                                                    </td>
                                                    <td style={{ padding: "5px 20px" }} class="text-end">
                                                      {data.itemGst}
                                                    </td>
                                                  </tr>
                                                );
                                              })}
                                            </table>
                                            <hr class="mt-4" />
                                            <table className="table">
                                              <tr>
                                                <td style={{ padding: "3px 20px" }}>
                                                  <span>
                                                    Tot.Taxable Amt : <b>{parseFloat(total).toFixed(2)}</b>
                                                  </span>
                                                </td>
                                                {getData?.dealerData?.gstType === "SGST" ? (
                                                  <>
                                                    <td style={{ padding: "3px 20px" }}>
                                                      <span>
                                                        SGST Amt : <b>{parseFloat(gst).toFixed(2)}</b>
                                                      </span>
                                                    </td>
                                                    <td style={{ padding: "3px 20px" }}>
                                                      <span>
                                                        CGST Amt : <b>{parseFloat(gst).toFixed(2)}</b>
                                                      </span>
                                                    </td>
                                                  </>
                                                ) : (
                                                  <td style={{ padding: "3px 20px" }}>
                                                    <span>
                                                      IGST Amt : <b>{parseFloat(gst * 2).toFixed(2)}</b>
                                                    </span>
                                                  </td>
                                                )}
                                                <td style={{ padding: "3px 20px" }}>
                                                  <span>
                                                    Other Amount : <b>(-){parseFloat(discount).toFixed(2)}</b>
                                                  </span>
                                                </td>
                                                <td style={{ padding: "3px 20px" }}>
                                                  <span>
                                                    Total Inv Amt :{" "}
                                                    <b>
                                                      {parseFloat(
                                                        total + gst * 2 - parseFloat(discount)
                                                      ).toFixed(2)}
                                                    </b>
                                                  </span>
                                                </td>
                                              </tr>
                                            </table>
                                            <hr class="mt-4" />

                                <table class="table">
                                    <tr>
                                        <th colspan="2" style={{padding: '20px 0px'}}>4. Transportation Details</th>
                                    </tr>
                                    <tr>
                                        <td style={{padding: '0px 20px'}}><span>Transporter ID : </span></td>
                                        <td style={{padding: '0px 20px'}}><span>Doc No. :</span></td>
                                    </tr>
                                    <tr>
                                        <td className="text-dark border-bottom" style={{padding: '0px 20px'}}><span>Name : </span></td>
                                        <td className="text-dark border-bottom" style={{padding: '0px 20px'}}><span>Date :</span></td>
                                    </tr>
                                </table>

                                <table class="table">
                                    <tr>
                                        <th colspan="3" style={{padding: '20px 0px'}}>5. Vehicle Details</th>
                                    </tr>
                                    <tr>
                                        <td style={{padding: '0px 20px'}}><span>Vehicle No. : <b>{getData?.vNum}</b></span></td>
                                        <td style={{padding: '0px 20px'}}><span>From : <b>{getData?.dispatch?.location}</b></span></td>
                                        <td style={{padding: '0px 20px'}}><span>CEWB No. :</span></td>
                                    </tr>
                                   
                                </table>

                            </div>
                           
                                                          

                        </div>
        </section>


        {/* --------------Sheet 3 ------------ */}

        <section className="invoice hide" id="printableArea3"  style={{ maxWidth: '100%', padding: '10mm', boxSizing: 'border-box', border: '1px solid #000', justifyContent: 'center' }}>
                        <div style={{marginTop: '-10px', marginBottom: '10px'}}>
                            <small >( TRIPLICATE FOR SUPPLIER )</small>
                        </div>
                        
                        <div className="row align-items-center justify-content-md-center h-p100">
                            <div className="col-sm-2">
                                <img src={Logo} width="100%" />
                            </div>

                            <div className="col-sm-5 text-fade" align="left">
                                <h6 className="text-left text-dark" style={{fontWeight: '600'}}>{companyData?.companyName}</h6>
                                <address className="text-left">
                                    {companyData?.companyAddress1}, {companyData?.companyAddress2}
                                    <br></br>
                                    {companyData?.companyLocation}, {companyData?.companyCity},
                                    {companyData?.companyState} - {companyData?.companyZip} <br />
                                    Ph: {companyData?.companyPhone}<br />
                                    {companyData?.companyGst}<br />
                                </address>
                            </div>

                            <div className="col-sm-3 d-flex" align="left">
                               <p class="text-dark">
                                Date : {formatViewDate(getData?.date)}<br />
                                DC No : DC/{getData?.invoiceId}/{getFiscalYearLabel(new Date(getData?.date))}<br />
                                {/* Route : {getData?.dealerData?.routes} <br />
                                Place : {getData?.dealerData?.locations}<br /> */}
                                Vehicle No : {getData?.vNum}<br />
                                E-Way Bill : {getData?.eWayNum}
                               </p>
                            </div>

                            <div className="col-sm-2 d-flex justify-content-end mb-4">
                               {/* <img src={Qr} alt="QR Code" width="200px" style={{marginRight: '-20px'}} /> */}
                               { payable && payable > 0 && <QRCodeCanvas value={generateUpiLink()} size={150}  /> }
                            </div>


                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th className="text-center" colspan="3">Delivery Chellan</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td width="33.333%" className="text-dark">
                                                <address >
                                                    <p className="text-dark text-uppercase">Billing Address</p>
                                                    <h6 style={{fontWeight: '600', fontSize: '14px'}}>{getData?.dealerData?.dealer}</h6>
                                                    {/* <p>{getData?.dealerData?.name}</p> */}
                                                    <p>{getData?.dealerData?.address}</p>
                                                    <p>{getData?.dealerData?.phone}<br />{getData?.dealerData?.email}</p>
                                                    GSTIN : &nbsp;&nbsp;&nbsp;{getData?.dealerData?.gst}<br />
                                                    State : &nbsp;&nbsp;&nbsp;{getData?.dealerData?.state} &nbsp;&nbsp;&nbsp;
                                                    Code : &nbsp;&nbsp;&nbsp;{getData?.dealerData?.stateCode}
                                                </address>
                                            </td>
                                            <td width="33.333%" className="text-dark" style={{verticalAlign: 'top'}}>
                                                <address >
                                                    <p className="text-dark text-uppercase">Shipping Address</p>
                                                    <h6 style={{fontWeight: '600', fontSize: '14px'}}>{getData?.shipping?.company}</h6>
                                                    {/* <p>{getData?.name}</p> */}
                                                    <p>{getData?.shipping?.sddress}</p>
                                                    <p>{getData?.shipping?.phone}<br />{getData?.shipping?.email}</p>
                                                </address>
                                            </td>
                                            <td className="text-dark" style={{verticalAlign: 'top'}}>
                                                <address >
                                                    <p className="text-dark text-uppercase">Dispatch From</p>
                                                    <h6 style={{fontWeight: '600', fontSize: '14px'}}>{getData?.dispatch?.company}</h6>
                                                    {/* <p>{getData?.name}</p> */}
                                                    <p>{getData?.dispatch?.address}</p>
                                                    <p>{getData?.dispatch?.phone}<br />{getData?.dispatch?.email}</p>
                                                </address>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="table-responsive ">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr className="fs-10 fw-600 text-dark">
                                            <th rowspan="2" width="3%">S.No</th>
                                            <th rowspan="2">PARTICULARS</th>
                                            <th rowspan="2" width="8%">HSN/SAC</th>
                                            <th rowspan="2" width="4%">UNIT</th>
                                            <th rowspan="2" width="8%">CRATES</th>
                                            <th rowspan="2" width="8%">QTY</th>
                                            <th rowspan="2" width="8%">LTR/KG</th>
                                            <th rowspan="2" width="6%">RATE/QTY</th>
                                            <th rowspan="2" width="8%">AMOUNT</th>
                                            {getData?.dealerData?.gstType === 'SGST' ? 
                                                <>
                                                    <th colspan="2" width="8%">CGST</th>   
                                                    <th colspan="2" width="8%">SGST</th>
                                                </>
                                            :
                                                <th colspan="2" width="8%">IGST</th>  
                                            }
                                            <th rowspan="2" width="10%">Total Amount</th>
                                        </tr>
                                        <tr className="fs-10 fw-800 text-dark">
                                            {getData?.dealerData?.gstType === 'SGST' && 
                                            <>
                                                <th>Rate(%) </th>
                                                <th>Value </th>
                                            </>
                                            }
                                          <th>Rate(%) </th>
                                          <th>Value </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {getData?.orderData?.map((data, index) => {
                                          
                                            const price = parseFloat(data.itemPrice);
                                            const gst = parseFloat(data.itemGst);
                                            const productGst = parseFloat(price - ( price / (1+ gst/100) ));
                                            const productPrice = parseFloat(price - productGst);
                                            const disCrates = getDiscountCrates(data.itemId);

                                            return(
                                            <tr key={index} className="fw-400 text-gray-600  fs-12">
                                                <td>{index + 1}</td> 
                                                <td class="text-left">{data.itemName}</td>
                                                <td class="text-left">{data.itemHsn}</td>
                                                <td>{data.itemUnit}</td>
                                                <td>{((parseFloat(data.qty) + parseFloat(disCrates))).toFixed(2)}</td>
                                                <td>{((parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)).toFixed(2)}</td>
                                                <td>{((parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade) * parseFloat(data.itemWeight)/1000).toFixed(2)}</td>
                                                <td>{parseFloat(productPrice).toFixed(2)}</td>
                                                <td>{parseFloat(productPrice.toFixed(2)* (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)).toFixed(2)}</td>
                                                {getData?.dealerData?.gstType === 'SGST' ?
                                                    <>
                                                        <td>{parseFloat(data.itemGst/2).toFixed(1)}%</td>
                                                        <td>{parseFloat((productGst/2) * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)).toFixed(2)}</td>
                                                        <td>{parseFloat(data.itemGst/2).toFixed(1)}%</td>
                                                        <td>{parseFloat((productGst/2) * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)).toFixed(2)}</td>
                                                    </>
                                                :
                                                    <>
                                                        <td>{parseFloat(data.itemGst).toFixed(1)}%</td>
                                                        <td>{parseFloat((productGst) * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)).toFixed(2)}</td>
                                                    </>
                                                }
                                                <td class="text-end">{(parseFloat(data.itemPrice) * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)).toFixed(2)}</td>

                                                                                                
                                            </tr>);
                                           })}
                                       
                                        <tr>
                                            
                                        <th colspan="4">TOTAL</th>
                                           
                                           <th>{parseFloat(crates).toFixed(2)}</th>
                                           <th>{parseFloat(qty).toFixed(2)}</th>
                                           <th>{parseFloat(weight).toFixed(2)}</th>
                                           <th></th>
                                           <th>{parseFloat(total).toFixed(2)}</th>
                                           {getData?.dealerData?.gstType === 'SGST' ?
                                                <>
                                                    <th></th>
                                                    <th>{parseFloat(gst/2).toFixed(2)}</th>
                                                    <td></td>
                                                    <th>{parseFloat(gst/2).toFixed(2)}</th>
                                                </>
                                           : 
                                                <>
                                                    <td></td>
                                                    <th>{parseFloat(gst).toFixed(2)}</th>
                                                </>
                                            }
                                           <th class="text-end">{parseFloat(grandTotal).toFixed(2)}</th>

   
                                        </tr>
                                        <tr>
                                            <td  className="text-center" colSpan={getData?.dealerData?.gstType === 'SGST' ? 8 : 7}>
                                                Our Bank Details
                                            </td>
                                            <td className="text-left" colSpan={getData?.dealerData?.gstType === 'SGST' ? 7 : 6} rowspan="2">
                                                <small>We request you to make the payment through our UPI ID <br />QR919843022841-0082@unionbankofindia</small>
                                            </td>
                                        </tr>
                                        <tr>
                                        <td  className="text-end" colSpan="2">
                                                <span>A/C Holder</span> <br />
                                                <span>BANK</span><br />
                                                <span>BRANCH</span>  <br />
                                                <span>A/C NO</span> <br />
                                                <span>IFSC CODE</span>
                                            </td>
                                            <td  className="text-left" colSpan={getData?.dealerData?.gstType === 'SGST' ? 7 : 6}>
                                                <span>TRUCOO DAIRY PRODUCTS PRIVATE LIMITED</span> <br />
                                                <span>UNION BANK OF INDIA</span><br />
                                                <span>COIMBATORE</span> <br />
                                                <span>008311010000082</span> <br />
                                                <span>UBIN0800830</span>
                                            </td>
                                        </tr>
                                       
                                       
                                        <tr>
                                            <td className="text-left" colSpan={getData?.dealerData?.gstType === 'SGST' ? 9 : 7} >Electronic Referance Number :</td>
                                            <td className="text-left" colSpan="3">BILL AMOUNT</td>
                                            <td class="text-end" colSpan="2">{parseFloat(grandTotal).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <th className="text-start" colSpan={getData?.dealerData?.gstType === 'SGST' ? 9 : 7} rowspan="3" style={{padding: '15px 5px'}}>
                                                Payable Amount In words <br />{totalAmountInWords.toUpperCase()} RUPEES ONLY
                                            </th>
                                            <td className="text-left" colSpan="3">DISCOUNT</td>
                                            <td class="text-end" colSpan="2">{parseFloat(discount + scheme).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td className="text-left" colSpan="3" style={{padding: '15px 5px'}}>ROUND AMOUNT</td>
                                            <td class="text-end" colSpan="2">{parseFloat(Math.round(payable)).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                           
                                            <th className="text-left" colSpan="3">GRAND TOTAL</th>
                                            <th class="text-end" colSpan="2">{parseFloat(Math.round(payable)).toFixed(2)}</th>
                                        </tr>
                                        <tr>
                                            
                                        </tr>
                                        <tr>
                                            <td className="text-left" colSpan="5">E. & O.E</td>
                                            <td className="text-center" colSpan="9">{companyData?.companyName}</td>
                                        </tr>
                                        <tr>
                                          <td className="text-left" colSpan="2" style={{paddingBottom: '90px'}}>Received By</td>
                                          <td className="text-left" colSpan="3" style={{paddingBottom: '90px'}}>Prepared By  <br /><br />{userName}</td>
                                          <td className="text-left" colSpan="4" style={{paddingBottom: '90px'}}>Declaration <br />
                                          We declare that this invoice shows the actual price of the goods described and that all particulars are true and correct.</td>
                                          <td className="text-left" colSpan="5" style={{paddingBottom: '90px'}}>Authorized Signature</td>
                                        </tr>
                                        <tr>
                                            <td className="text-center" colSpan="14" >This is a Computer Generated Invoice</td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>                                           

                        </div>
        </section>

        {/* --------------Sheet 4 ------------ */}

        <section className="invoice hide" id="printableArea4"  style={{ maxWidth: '100%', padding: '10mm', boxSizing: 'border-box', border: '1px solid #000', justifyContent: 'center' }}>
                        <div style={{marginTop: '-10px', marginBottom: '10px'}}>
                            <small >( EXTRA COPY )</small>
                        </div>
                        <div className="row align-items-center justify-content-md-center h-p100">
                            <div className="col-sm-2">
                                <img src={Logo} width="100%" />
                            </div>

                            <div className="col-sm-5 text-fade" align="left">
                                <h6 className="text-left text-dark" style={{fontWeight: '600'}}>{companyData?.companyName}</h6>
                                <address className="text-left">
                                    {companyData?.companyAddress1}, {companyData?.companyAddress2}
                                    <br></br>
                                    {companyData?.companyLocation}, {companyData?.companyCity},
                                    {companyData?.companyState} - {companyData?.companyZip} <br />
                                    Ph: {companyData?.companyPhone}<br />
                                    {companyData?.companyGst}<br />
                                </address>
                            </div>

                            <div className="col-sm-3 d-flex" align="left">
                               <p class="text-dark">
                                Date : {formatViewDate(getData?.date)}<br />
                                DC No : DC/{getData?.invoiceId}/{getFiscalYearLabel(new Date(getData?.date))}<br />
                                {/* Route : {getData?.dealerData?.routes} <br />
                                Place : {getData?.dealerData?.locations}<br /> */}
                                Vehicle No : {getData?.vNum}<br />
                                E-Way Bill : {getData?.eWayNum}
                               </p>
                            </div>

                            <div className="col-sm-2 d-flex justify-content-end mb-4">
                               {/* <img src={Qr} alt="QR Code" width="200px" style={{marginRight: '-20px'}} /> */}
                               { payable && payable > 0 && <QRCodeCanvas value={generateUpiLink()} size={150}  /> }
                            </div>


                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th className="text-center" colspan="3">Delivery Chellan</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td width="33.333%" className="text-dark">
                                                <address >
                                                    <p className="text-dark text-uppercase">Billing Address</p>
                                                    <h6 style={{fontWeight: '600', fontSize: '14px'}}>{getData?.dealerData?.dealer}</h6>
                                                    {/* <p>{getData?.dealerData?.name}</p> */}
                                                    <p>{getData?.dealerData?.address}</p>
                                                    <p>{getData?.dealerData?.phone}<br />{getData?.dealerData?.email}</p>
                                                    GSTIN : &nbsp;&nbsp;&nbsp;{getData?.dealerData?.gst}<br />
                                                    State : &nbsp;&nbsp;&nbsp;{getData?.dealerData?.state} &nbsp;&nbsp;&nbsp;
                                                    Code : &nbsp;&nbsp;&nbsp;{getData?.dealerData?.stateCode}
                                                </address>
                                            </td>
                                            <td width="33.333%" className="text-dark" style={{verticalAlign: 'top'}}>
                                                <address >
                                                    <p className="text-dark text-uppercase">Shipping Address</p>
                                                    <h6 style={{fontWeight: '600', fontSize: '14px'}}>{getData?.shipping?.company}</h6>
                                                    {/* <p>{getData?.name}</p> */}
                                                    <p>{getData?.shipping?.address}</p>
                                                    <p>{getData?.shipping?.phone}<br />{getData?.shipping?.email}</p>
                                                </address>
                                            </td>
                                            <td className="text-dark" style={{verticalAlign: 'top'}}>
                                                <address >
                                                    <p className="text-dark text-uppercase">Dispatch From</p>
                                                    <h6 style={{fontWeight: '600', fontSize: '14px'}}>{getData?.dispatch?.company}</h6>
                                                    {/* <p>{getData?.name}</p> */}
                                                    <p>{getData?.dispatch?.address}</p>
                                                    <p>{getData?.dispatch?.phone}<br />{getData?.dispatch?.email}</p>
                                                </address>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="table-responsive ">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr className="fs-10 fw-600 text-dark">
                                            <th rowspan="2" width="3%">S.No</th>
                                            <th rowspan="2">PARTICULARS</th>
                                            <th rowspan="2" width="8%">HSN/SAC</th>
                                            <th rowspan="2" width="4%">UNIT</th>
                                            <th rowspan="2" width="8%">CRATES</th>
                                            <th rowspan="2" width="8%">QTY</th>
                                            <th rowspan="2" width="8%">LTR/KG</th>
                                            <th rowspan="2" width="6%">RATE/QTY</th>
                                            <th rowspan="2" width="8%">AMOUNT</th>
                                            {getData?.dealerData?.gstType === 'SGST' ? 
                                                <>
                                                    <th colspan="2" width="8%">CGST</th>   
                                                    <th colspan="2" width="8%">SGST</th>
                                                </>
                                            :
                                                <th colspan="2" width="8%">IGST</th>  
                                            }
                                            <th rowspan="2" width="10%">Total Amount</th>
                                        </tr>
                                        <tr className="fs-10 fw-800 text-dark">
                                            {getData?.dealerData?.gstType === 'SGST' && 
                                            <>
                                                <th>Rate(%) </th>
                                                <th>Value </th>
                                            </>
                                            }
                                          <th>Rate(%) </th>
                                          <th>Value </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {getData?.orderData?.map((data, index) => {
                                          
                                            const price = parseFloat(data.itemPrice);
                                            const gst = parseFloat(data.itemGst);
                                            const productGst = parseFloat(price - ( price / (1+ gst/100) ));
                                            const productPrice = parseFloat(price - productGst);
                                            const disCrates = getDiscountCrates(data.itemId);

                                            return(
                                            <tr key={index} className="fw-400 text-gray-600  fs-12">
                                                <td>{index + 1}</td> 
                                                <td class="text-left">{data.itemName}</td>
                                                <td class="text-left">{data.itemHsn}</td>
                                                <td>{data.itemUnit}</td>
                                                <td>{((parseFloat(data.qty) + parseFloat(disCrates))).toFixed(2)}</td>
                                                <td>{((parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)).toFixed(2)}</td>
                                                <td>{((parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade) * parseFloat(data.itemWeight)/1000).toFixed(2)}</td>
                                                <td>{parseFloat(productPrice).toFixed(2)}</td>
                                                <td>{parseFloat(productPrice.toFixed(2)* (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)).toFixed(2)}</td>
                                                {getData?.dealerData?.gstType === 'SGST' ?
                                                    <>
                                                        <td>{parseFloat(data.itemGst/2).toFixed(1)}%</td>
                                                        <td>{parseFloat((productGst/2) * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)).toFixed(2)}</td>
                                                        <td>{parseFloat(data.itemGst/2).toFixed(1)}%</td>
                                                        <td>{parseFloat((productGst/2) * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)).toFixed(2)}</td>
                                                    </>
                                                :
                                                    <>
                                                        <td>{parseFloat(data.itemGst).toFixed(1)}%</td>
                                                        <td>{parseFloat((productGst) * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)).toFixed(2)}</td>
                                                    </>
                                                }
                                                <td class="text-end">{(parseFloat(data.itemPrice) * (parseFloat(data.qty) + parseFloat(disCrates)) * parseFloat(data.itemGrade)).toFixed(2)}</td>

                                                                                                
                                            </tr>);
                                           })}
                                       
                                        <tr>
                                            
                                        <th colspan="4">TOTAL</th>
                                           
                                           <th>{parseFloat(crates).toFixed(2)}</th>
                                           <th>{parseFloat(qty).toFixed(2)}</th>
                                           <th>{parseFloat(weight).toFixed(2)}</th>
                                           <th></th>
                                           <th>{parseFloat(total).toFixed(2)}</th>
                                           {getData?.dealerData?.gstType === 'SGST' ?
                                                <>
                                                    <th></th>
                                                    <th>{parseFloat(gst/2).toFixed(2)}</th>
                                                    <td></td>
                                                    <th>{parseFloat(gst/2).toFixed(2)}</th>
                                                </>
                                           : 
                                                <>
                                                    <td></td>
                                                    <th>{parseFloat(gst).toFixed(2)}</th>
                                                </>
                                            }
                                           <th class="text-end">{parseFloat(grandTotal).toFixed(2)}</th>

   
                                        </tr>
                                        <tr>
                                            <td  className="text-center" colSpan={getData?.dealerData?.gstType === 'SGST' ? 8 : 7}>
                                                Our Bank Details
                                            </td>
                                            <td className="text-left" colSpan={getData?.dealerData?.gstType === 'SGST' ? 7 : 6} rowspan="2">
                                                <small>We request you to make the payment through our UPI ID <br />QR919843022841-0082@unionbankofindia</small>
                                            </td>
                                        </tr>
                                        <tr>
                                        <td  className="text-end" colSpan="2">
                                                <span>A/C Holder</span> <br />
                                                <span>BANK</span><br />
                                                <span>BRANCH</span>  <br />
                                                <span>A/C NO</span> <br />
                                                <span>IFSC CODE</span>
                                            </td>
                                            <td  className="text-left" colSpan={getData?.dealerData?.gstType === 'SGST' ? 7 : 6}>
                                                <span>TRUCOO DAIRY PRODUCTS PRIVATE LIMITED</span> <br />
                                                <span>UNION BANK OF INDIA</span><br />
                                                <span>COIMBATORE</span> <br />
                                                <span>008311010000082</span> <br />
                                                <span>UBIN0800830</span>
                                            </td>
                                        </tr>
                                       
                                       
                                        <tr>
                                            <td className="text-left" colSpan={getData?.dealerData?.gstType === 'SGST' ? 9 : 7} >Electronic Referance Number :</td>
                                            <td className="text-left" colSpan="3">BILL AMOUNT</td>
                                            <td class="text-end" colSpan="2">{parseFloat(grandTotal).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <th className="text-start" colSpan={getData?.dealerData?.gstType === 'SGST' ? 9 : 7} rowspan="3" style={{padding: '15px 5px'}}>
                                                Payable Amount In words <br />{totalAmountInWords.toUpperCase()} RUPEES ONLY
                                            </th>
                                            <td className="text-left" colSpan="3">DISCOUNT</td>
                                            <td class="text-end" colSpan="2">{parseFloat(discount + scheme).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td className="text-left" colSpan="3" style={{padding: '15px 5px'}}>ROUND AMOUNT</td>
                                            <td class="text-end" colSpan="2">{parseFloat(Math.round(payable)).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                           
                                            <th className="text-left" colSpan="3">GRAND TOTAL</th>
                                            <th class="text-end" colSpan="2">{parseFloat(Math.round(payable)).toFixed(2)}</th>
                                        </tr>
                                        <tr>
                                            
                                        </tr>
                                        <tr>
                                            <td className="text-left" colSpan="5">E. & O.E</td>
                                            <td className="text-center" colSpan="9">{companyData?.companyName}</td>
                                        </tr>
                                        <tr>
                                          <td className="text-left" colSpan="2" style={{paddingBottom: '90px'}}>Received By</td>
                                          <td className="text-left" colSpan="3" style={{paddingBottom: '90px'}}>Prepared By  <br /><br />{userName}</td>
                                          <td className="text-left" colSpan="4" style={{paddingBottom: '90px'}}>Declaration <br />
                                          We declare that this invoice shows the actual price of the goods described and that all particulars are true and correct.</td>
                                          <td className="text-left" colSpan="5" style={{paddingBottom: '90px'}}>Authorized Signature</td>
                                        </tr>
                                        <tr>
                                            <td className="text-center" colSpan="14" >This is a Computer Generated Invoice</td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>                                           

                        </div>
        </section>


        
    </>
    );
}
    
export default InvoicePage;
    